// Verbatim from handover — unchanged

import React, { useState } from 'react';
import { CalendarDays, TableProperties, History } from 'lucide-react';
import { TabId } from './types';
import { BookingsTab } from './components/BookingsTab';
import { SheetTab } from './components/SheetTab';
import { SyncLogTab } from './components/SyncLogTab';

const TABS: { id: TabId; label: string; icon: React.ReactNode }[] = [
  { id: 'bookings', label: 'Upcoming Bookings', icon: <CalendarDays size={15} /> },
  { id: 'sheet',    label: 'Cleaning Sheet',    icon: <TableProperties size={15} /> },
  { id: 'synclog',  label: 'Sync Log',          icon: <History size={15} /> },
];

const App: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabId>('bookings');

  return (
    <div className="min-h-screen bg-base-100 flex flex-col">
      {/* Header */}
      <div className="bg-primary text-primary-content px-4 py-3 shadow">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-lg font-bold tracking-tight">Villa Luar</h1>
            <p className="text-xs text-primary-content/70">Solmar Booking Dashboard</p>
          </div>
          <div className="badge badge-primary-content border-primary-content/30 text-xs">
            Auto-syncs Mondays
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="tabs tabs-bordered bg-base-200 px-4 pt-2">
        {TABS.map(tab => (
          <button
            key={tab.id}
            className={`tab gap-2 text-sm ${activeTab === tab.id ? 'tab-active font-semibold' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.icon}
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content */}
      <div className="flex-1 overflow-auto">
        {activeTab === 'bookings' && <BookingsTab />}
        {activeTab === 'sheet'    && <SheetTab />}
        {activeTab === 'synclog'  && <SyncLogTab />}
      </div>
    </div>
  );
};

export default App;
